/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendDataDto } from '../models/backend-data-dto';
import { monitoringPlanBalanceDataRetrieve } from '../fn/monitoring-plan/monitoring-plan-balance-data-retrieve';
import { MonitoringPlanBalanceDataRetrieve$Params } from '../fn/monitoring-plan/monitoring-plan-balance-data-retrieve';
import { monitoringPlanCashFlowPlanDataRetrieve } from '../fn/monitoring-plan/monitoring-plan-cash-flow-plan-data-retrieve';
import { MonitoringPlanCashFlowPlanDataRetrieve$Params } from '../fn/monitoring-plan/monitoring-plan-cash-flow-plan-data-retrieve';
import { monitoringPlanProfitAndLossPlanDataRetrieve } from '../fn/monitoring-plan/monitoring-plan-profit-and-loss-plan-data-retrieve';
import { MonitoringPlanProfitAndLossPlanDataRetrieve$Params } from '../fn/monitoring-plan/monitoring-plan-profit-and-loss-plan-data-retrieve';
import { monitoringPlanResultFinAnalysDataRetrieve } from '../fn/monitoring-plan/monitoring-plan-result-fin-analys-data-retrieve';
import { MonitoringPlanResultFinAnalysDataRetrieve$Params } from '../fn/monitoring-plan/monitoring-plan-result-fin-analys-data-retrieve';
import { monitoringPlanSalesPlanRetrieve } from '../fn/monitoring-plan/monitoring-plan-sales-plan-retrieve';
import { MonitoringPlanSalesPlanRetrieve$Params } from '../fn/monitoring-plan/monitoring-plan-sales-plan-retrieve';
import { BackendMonitoringSalesPlanFacadeDto } from '../models/backend-monitoring-sales-plan-facade-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiMonitoringPlanService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringPlanBalanceDataRetrieve()` */
  static readonly MonitoringPlanBalanceDataRetrievePath = '/api/monitoring/plan/balance_data/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringPlanBalanceDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanBalanceDataRetrieve$Response(
    params: MonitoringPlanBalanceDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringPlanBalanceDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringPlanBalanceDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanBalanceDataRetrieve(
    params: MonitoringPlanBalanceDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringPlanBalanceDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringPlanCashFlowPlanDataRetrieve()` */
  static readonly MonitoringPlanCashFlowPlanDataRetrievePath =
    '/api/monitoring/plan/cash_flow_plan_data/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringPlanCashFlowPlanDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanCashFlowPlanDataRetrieve$Response(
    params: MonitoringPlanCashFlowPlanDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringPlanCashFlowPlanDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringPlanCashFlowPlanDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanCashFlowPlanDataRetrieve(
    params: MonitoringPlanCashFlowPlanDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringPlanCashFlowPlanDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringPlanProfitAndLossPlanDataRetrieve()` */
  static readonly MonitoringPlanProfitAndLossPlanDataRetrievePath =
    '/api/monitoring/plan/profit_and_loss_plan_data/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringPlanProfitAndLossPlanDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanProfitAndLossPlanDataRetrieve$Response(
    params: MonitoringPlanProfitAndLossPlanDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringPlanProfitAndLossPlanDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringPlanProfitAndLossPlanDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanProfitAndLossPlanDataRetrieve(
    params: MonitoringPlanProfitAndLossPlanDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringPlanProfitAndLossPlanDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringPlanResultFinAnalysDataRetrieve()` */
  static readonly MonitoringPlanResultFinAnalysDataRetrievePath =
    '/api/monitoring/plan/result_fin_analys_data/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringPlanResultFinAnalysDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanResultFinAnalysDataRetrieve$Response(
    params: MonitoringPlanResultFinAnalysDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringPlanResultFinAnalysDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringPlanResultFinAnalysDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanResultFinAnalysDataRetrieve(
    params: MonitoringPlanResultFinAnalysDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringPlanResultFinAnalysDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringPlanSalesPlanRetrieve()` */
  static readonly MonitoringPlanSalesPlanRetrievePath = '/api/monitoring/plan/sales_plan/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringPlanSalesPlanRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanSalesPlanRetrieve$Response(
    params: MonitoringPlanSalesPlanRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMonitoringSalesPlanFacadeDto>> {
    return monitoringPlanSalesPlanRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringPlanSalesPlanRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringPlanSalesPlanRetrieve(
    params: MonitoringPlanSalesPlanRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendMonitoringSalesPlanFacadeDto> {
    return this.monitoringPlanSalesPlanRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMonitoringSalesPlanFacadeDto>): BackendMonitoringSalesPlanFacadeDto => r.body),
    );
  }
}
